module.exports = __webpack_public_path__ + "static/nietzsche-beyond-good-and-evil-ad6dcf8e66e5889aeae255f1cfab5891.jpg";